export default __webpack_public_path__ + "static/media/book.c8a3953c.png";